export default "__VITE_ASSET__90c35be6__"